import axios from 'axios'
import Vue from 'vue'

let API_BASE = new Vue({
    data: () => ({
        conexiones: [],
        Llamando: false,
        respuestaOK: '',
        respuestaError: '',
        respuestaConexion: ''
    }),
    created() {
        let hostBase = '';

        if (process.env.NODE_ENV === 'development') {
            hostBase = 'https://localhost:30000';
        } else if (window.location.href.includes("test")) {
            hostBase = 'https://smartapi2test.smartlabs.es:30002';
        } else if (window.location.href.includes("pruebas")) {
            hostBase = 'http://smartapipruebas.smartlabs.es';
        } else {
            // En producción (IIS), todas las llamadas van a través del Proxy
            hostBase = '/api-proxy';
        }

        // Instancias de Axios (SIN credenciales ni Basic Auth expuestas)
        this.conexiones.comun = axios.create({ baseURL: `${hostBase}/SmartLabs` });
        this.conexiones.websat = axios.create({ baseURL: `${hostBase}/telefonica/webSat` });
        this.conexiones.websatRent = axios.create({ baseURL: `${hostBase}/telefonica/webSatRent` });
        this.conexiones.websatSuscripcion = axios.create({ baseURL: `${hostBase}/telefonica/webSatSuscripcion` });

        // Instancia para traducir
        this.conexiones.websatTranslated = axios.create({ baseURL: `${hostBase}/telefonica/webSat` });

        // Interceptor solo para enviar el idioma actual
        this.conexiones.websatTranslated.interceptors.request.use(config => {
            if (this.$i18n && this.$i18n.locale) {
                config.headers['Accept-Language'] = this.$i18n.locale;
            }
            return config;
        }, error => Promise.reject(error));
    },
    computed: {
        basicRequest() { return {}; }
    },
    methods: {
        createRequest(parametrosRequest = {}, mostrarSpin = true) {
            if (mostrarSpin) this.Llamando = true;
            return { ...this.basicRequest, ...parametrosRequest };
        },
        handleExito(respuesta, mostrarMensajeOK = true) {
            this.Llamando = false;
            this.respuestaConexion = '';
            if (respuesta.data.token) this.tokenSesion = respuesta.data.token;

            if (respuesta.data.codigo == 0) {
                if (mostrarMensajeOK) this.respuestaOK = respuesta.data.mensaje;
                return respuesta.data;
            } else {
                this.respuestaError = respuesta.data.mensaje;
                return '';
            }
        },
        handleError(error, mostrarMensaje = true) {
            console.log('handler error ' + mostrarMensaje + " - " + error);
            this.Llamando = false;
            if (mostrarMensaje && error.message === 'Network Error') {
                this.respuestaConexion = '¡ERROR! No se ha podido conectar con el servidor, contacte con nuestro soporte técnico';
            }
            return '';
        }
    }
});

/******************************************* LLAMADAS A API *********************************************/

// Comun / SmartLabs
API_BASE.postCodes = function () {
    return API_BASE.conexiones.comun.post('/postCodes', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

// WebSat
API_BASE.getBasicData = function (keys) {
    return API_BASE.conexiones.websat.post('/getBasicData', API_BASE.createRequest(keys))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getOrdenEstados = function (keys) {
    return API_BASE.conexiones.websat.post('/getOrdenEstados', API_BASE.createRequest(keys))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.login = function (json) {
    return API_BASE.conexiones.websat.post('/login', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.registro = function (json) {
    return API_BASE.conexiones.websat.post('/registro', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.comprobarCredenciales = function (json) {
    return API_BASE.conexiones.websat.post('/comprobarCredenciales', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.cambiarPasswordParticular = function (json) {
    return API_BASE.conexiones.websat.post('/cambiarPasswordParticular', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.comprobarCodigoPostal = function (json) {
    return API_BASE.conexiones.websat.post('/comprobarCodigoPostal', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.newRepair = function (json) {
    return API_BASE.conexiones.websat.post('/newRepair', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getTienda = function (json) {
    return API_BASE.conexiones.websat.post('/getTienda', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.expedicion = function (json) {
    return API_BASE.conexiones.websat.post('/expedicion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.guardarFactura = function (json) {
    return API_BASE.conexiones.websat.post('/guardarFactura', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.buscarOrden = function (json) {
    return API_BASE.conexiones.websat.post('/buscarOrden', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.descargarInformeReparacion = function (json) {
    return API_BASE.conexiones.websat.post('/descargarInformeReparacion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.descargarInformeIrreparable = function (json) {
    return API_BASE.conexiones.websat.post('/descargarInformeIrreparable', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.descargarFactura = function (json) {
    return API_BASE.conexiones.websat.post('/descargarFactura', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getEmpresaCatalogo = function (json) {
    return API_BASE.conexiones.websat.post('/getEmpresaCatalogo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getIdTallerMapeo = function (json) {
    return API_BASE.conexiones.websat.post('/getIdTallerMapeo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.recuperarPassword = function (json) {
    return API_BASE.conexiones.websat.post('/recuperarPassword', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.comprobarTokenRecuperarPassword = function (json) {
    return API_BASE.conexiones.websat.post('/comprobarTokenRecuperarPassword', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.cambiarPassword = function (json) {
    return API_BASE.conexiones.websat.post('/cambiarPassword', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getCatalogo = function (json) {
    return API_BASE.conexiones.websat.post('/getCatalogo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getDNIsEmailsActivos = function () {
    return API_BASE.conexiones.websat.post('/getDNIsEmailsActivos', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

API_BASE.getTiendas = function (v) {
    return API_BASE.conexiones.websat.post('/obtenerTiendasPorCP', API_BASE.createRequest({ cp: v }))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

API_BASE.CodigosPrescriptores = function () {
    return API_BASE.conexiones.websat.post('/CodigosPrescriptores', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

// WebSat Traducidos
API_BASE.getCatalogoTraducido = function (json) {
    return API_BASE.conexiones.websatTranslated.post('/getCatalogo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getDesplegablesTraducidos = function (json) {
    return API_BASE.conexiones.websatTranslated.post('/getDesplegables', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, true));
};

// WebSat Suscripcion
API_BASE.loginCliente = function (json, mostrarMensaje = true) {
    return API_BASE.conexiones.websatSuscripcion.post('/loginCliente', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, mostrarMensaje))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.validarCodigo = function (json) {
    return API_BASE.conexiones.websatSuscripcion.post('/validarCodigo', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.getTipoSuscripcionesDisponibles = function () {
    return API_BASE.conexiones.websatSuscripcion.post('/getTipoSuscripcionesDisponibles', API_BASE.createRequest())
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

API_BASE.seleccionarTipoSuscripcion = function (json) {
    return API_BASE.conexiones.websatSuscripcion.post('/seleccionarTipoSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

API_BASE.cobroSuscripcion = function (json) {
    return API_BASE.conexiones.websatSuscripcion.post('/cobroSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta))
        .catch(error => API_BASE.handleError(error));
};

API_BASE.cancelarSuscripcion = function (json) {
    return API_BASE.conexiones.websatSuscripcion.post('/cancelarSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

API_BASE.reactivarRenovacion = function (json) {
    return API_BASE.conexiones.websatSuscripcion.post('/reactivarRenovacion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

API_BASE.actualizarTarjeta = function (json) {
    return API_BASE.conexiones.websatSuscripcion.post('/actualizarTarjeta', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

API_BASE.anularSuscripcion = function (json) {
    return API_BASE.conexiones.websatSuscripcion.post('/anularSuscripcion', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, false));
};

// WebSat Rent
API_BASE.getDesplegables = function (json) {
    return API_BASE.conexiones.websatRent.post('/getDesplegables', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true));
};

API_BASE.resgistarIncidencia = function (json) {
    return API_BASE.conexiones.websatRent.post('/resgistarIncidencia', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true));
};

API_BASE.consultarIncidencia = async function (json) {
    return API_BASE.conexiones.websatRent.post('/consultarIncidencia', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true));
};

API_BASE.getlineasPublicasEstados = function (json) {
    return API_BASE.conexiones.websatRent.post('/getlineasPublicasEstados', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true));
};

API_BASE.getEstados = function (json) {
    return API_BASE.conexiones.websatRent.post('/getlineasPublicasEstados', API_BASE.createRequest(json))
        .then(respuesta => API_BASE.handleExito(respuesta, false))
        .catch(error => API_BASE.handleError(error, true));
};

// Instalar como plugin global de Vue ($API)
export default {
    install(Vue) {
        Vue.prototype.$API = API_BASE;
    }
};